export type BoundingRect = {
  y: number;
  x: number;
  width: number;
  height: number;
};
export function boundingRectOfPaths(
  paths: { points: { x: number; y: number }[] }[],
  lineWidth: number,
  scale: number
): BoundingRect {
  if (paths.length === 0) {
    return {
      y: 0,
      x: 0,
      width: 0,
      height: 0,
    };
  } else {
    const xCoordinates = paths.flatMap((path) =>
      path.points.map((point) => point.x)
    );
    const yCoordinates = paths.flatMap((path) =>
      path.points.map((point) => point.y)
    );
    let minX = Math.min(...xCoordinates);
    let minY = Math.min(...yCoordinates);
    let maxX = Math.max(...xCoordinates);
    let maxY = Math.max(...yCoordinates);
    return {
      x: (minX - lineWidth / 2) * scale,
      y: (minY - lineWidth / 2) * scale,
      height: (Math.abs(maxY - minY) + lineWidth) * scale,
      width: (Math.abs(maxX - minX) + lineWidth) * scale,
    };
  }
}
